// App.tsx — provider stack + router. (Was the prototype's app.jsx shell.)
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthProvider';
import { TenantGate } from '@/auth/TenantGate';
import { StoreProvider } from '@/store/store';
import { TaskTrackerProvider } from '@/foundation/TaskProgressFloat';
import { UpdateBanner } from '@/foundation/UpdateBanner';
import { router } from '@/routes';
import { createAppQueryClient } from '@/api/queryClient';

const queryClient = createAppQueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TenantGate>
        <AuthProvider>
          <StoreProvider>
            <TaskTrackerProvider>
              <RouterProvider router={router} />
              <UpdateBanner />
            </TaskTrackerProvider>
          </StoreProvider>
        </AuthProvider>
      </TenantGate>
    </QueryClientProvider>
  );
}
